import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = props => (
    <FontAwesomeIcon {...props} />
);

export default Icon;
